module.exports = __webpack_public_path__ + "static/media/LoveLighting.9395b33b.jpg";